const searchPin = {
    url: 'https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=pin%7cFC8056%7c000000&.png',
    width: '21px',
    height: '34px',
}

const selectedPin = {
    url: 'https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=test%7c5680FC%7c000000&.png',
    width: '21px',
    height: '34px',
}

const centerPin = {
    url: 'https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=center%7cf7dd38%7c000000&.png',
    width: '39px',
    height: '34px',
} 

const pins = {
    searchPin,
    selectedPin,
    centerPin,
}

export default pins